import { render, staticRenderFns } from "./lista_reportesemanal.vue?vue&type=template&id=56226bae&scoped=true"
import script from "./lista_reportesemanal.vue?vue&type=script&lang=js"
export * from "./lista_reportesemanal.vue?vue&type=script&lang=js"
import style0 from "./lista_reportesemanal.vue?vue&type=style&index=0&id=56226bae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56226bae",
  null
  
)

export default component.exports